import axios from 'axios';
import { getToken } from './auth2';

const instance = axios.create({
    baseURL: '/prod/'
});

export function updateAuthorizationToken(token: string): void {
    console.log('AI UAT')
    instance.defaults.headers.common['Authorization'] = token;
}

const token = getToken();
console.log('AI got token', token);
if (token) {
    console.log('AI updating token');
    updateAuthorizationToken(token);
}

export default instance;
